import { withStyles } from "@material-ui/core";
import { Theme } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

export const LoginButton = withStyles((theme: Theme) => ({
  root: {
    borderRadius: 0,
  },
}))(Button);
